module.exports = __webpack_public_path__ + "img/left-arrow.01992a7f.png";